import * as React from "react";

interface Probs {
  children?: React.ReactNode;
  index: any;
  value: any;
}

export class TabPanel extends React.Component<Probs, {}> {
  render() {
    const { children, value, index, ...other } = this.props;
    return (
      <div role="tabpanel" hidden={value !== index} {...other}>
        {value === index && <React.Fragment>{children}</React.Fragment>}
      </div>
    );
  }
}
